import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/bg-uk-react-native.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>
                Your Trusted React Native Development Company for Tech Solutions
              </h2>
            </div>
            <p>
              TekRevol is your ultimate solution for React Native app
              development, as we excel in both, existing and cutting-edge
              technologies. Our solutions for complex React Native app
              development streamline operations and improve overall performance.
              As a top-tier React Development agency, we understand your
              business objectives and create React Native apps that are
              customized to improve your digital presence and fit your company's
              specific demands.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
